export default (link) => {
  const linkID = link.toLowerCase();
  switch (linkID) {
    case "linkedin":
      return "https://www.linkedin.com/in/saanvi-iyer";
    case "github":
      return "https://github.com/saanvi-iyer";
    case "mail":
      return "mailto:saanvi.iyer007@gmail.com";
    case "porfolio":
      return "https://saanviiyer.in";

    default:
      break;
  }
};
